export const common = {
  nav: {
    services: 'Services',
    about: 'About',
    contact: 'Contact'
  },
  hero: {
    title: 'Professional Websites and SEO for Small Businesses',
    subtitle: 'I create modern, fast, and optimized websites to help local businesses grow online.',
    primaryBtn: 'Request information',
    secondaryBtn: 'View services'
  },
  services: {
    title: 'Services',
    web: {
      title: 'Website Creation',
      description: 'Design of modern, fast, and mobile-friendly websites for small businesses.'
    },
    seo: {
      title: 'Local SEO',
      description: 'Optimization to rank better on Google and attract more local customers.'
    },
    redesign: {
      title: 'Website Redesign',
      description: 'Transformation of old websites into modern and professional sites.'
    }
  },
  why: {
    title: 'Why Choose David Rio Web',
    point1: 'Modern and professional design',
    point2: 'Fast and optimized websites',
    point3: 'SEO-ready structure',
    point4: 'Multi-language support',
    point5: 'Solutions for small businesses'
  },
  languages: {
    title: 'Multilingual Services',
    description: 'I work with businesses that want to reach international customers.',
    spanish: 'Español',
    english: 'English',
    russian: 'Русский'
  },
  about: {
    title: 'About David Rio',
    description: 'Freelance web developer specialized in creating modern websites and SEO strategies for small businesses. My goal is to help local companies have a professional online presence.'
  },
  contact: {
    title: 'Contact',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    message: 'Message',
    submit: 'Contact',
    sending: 'Sending...',
    success: 'Message sent successfully!',
    error: 'Error sending message. Please try again.'
  },
  footer: {
    copyright: '© 2026 David Rio Web',
    credit: 'Website designed and created by David Rio'
  },
  portfolio: {
    title: 'Web Projects',
    description: 'Some examples of modern websites designed for small businesses.',
    project1: {
      title: 'Local Business Website',
      description: 'Modern website for a local service business with mobile optimization and fast loading.'
    },
    project2: {
      title: 'Restaurant Website',
      description: 'Professional website for a restaurant including menu, location and contact.'
    },
    project3: {
      title: 'Beauty Salon Website',
      description: 'Elegant website for a beauty salon with services and gallery.'
    }
  },
  process: {
    title: 'How I Work',
    step1: {
      title: 'Analysis',
      description: 'I study the business needs and client objectives.'
    },
    step2: {
      title: 'Design and Development',
      description: 'I create a modern, fast and optimized website.'
    },
    step3: {
      title: 'Launch and Optimization',
      description: 'The website is published and optimized for search engines.'
    }
  }
};